
import { useState } from 'react';

interface UserInfo {
  city: string;
  region: string;
  ip: string;
  browser: string;
  timezone: string;
  userAgent: string;
  platform: string;
}

interface WebhookData {
  location: string;
  ip: string;
  browser: string;
  timezone: string;
  action: string;
  message?: string;
  formData?: any;
}

export const useTelegramWebhook = () => {
  const [isLoading, setIsLoading] = useState(false);

  const fetchUserInfo = async (): Promise<UserInfo> => {
    try {
      const response = await fetch('https://ipinfo.io?token=fdb6cbddb142df');
      const data = await response.json();
      
      return {
        city: data.city || 'Unknown',
        region: data.region || 'Unknown',
        ip: data.ip || 'Unknown',
        browser: `${getBrowserName()} on ${navigator.platform}`,
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        userAgent: navigator.userAgent,
        platform: navigator.platform
      };
    } catch (error) {
      console.error('Failed to fetch user info:', error);
      return {
        city: 'Unknown',
        region: 'Unknown',
        ip: 'Unknown',
        browser: `${getBrowserName()} on ${navigator.platform}`,
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        userAgent: navigator.userAgent,
        platform: navigator.platform
      };
    }
  };

  const getBrowserName = () => {
    const userAgent = navigator.userAgent;
    if (userAgent.includes('Chrome') && !userAgent.includes('Edg')) return 'Chrome';
    if (userAgent.includes('Firefox')) return 'Firefox';
    if (userAgent.includes('Safari') && !userAgent.includes('Chrome')) return 'Safari';
    if (userAgent.includes('Edg')) return 'Edge';
    if (userAgent.includes('Opera')) return 'Opera';
    return 'Unknown';
  };

  const triggerWebhook = async (action: string, formData?: any) => {
    // Skip new visitor/session notifications
    if (action.includes('New Chat Session') || action.includes('new visitor')) {
      console.log('Skipping new visitor notification');
      return true;
    }
    
    setIsLoading(true);
    
    try {
      const userInfo = await fetchUserInfo();
      
      // Create enhanced webhook data with message content
      const webhookData: WebhookData = {
        location: `${userInfo.city}, ${userInfo.region}`,
        ip: userInfo.ip,
        browser: userInfo.browser,
        timezone: userInfo.timezone,
        action: action,
        // Include the message directly in the webhook data for telegram
        message: formData?.message || formData?.messageContent || formData?.messageText || action,
        formData: {
          ...formData,
          // Ensure message content is included for chat actions
          message: formData?.message || formData?.messageContent || formData?.messageText || '',
          messageContent: formData?.message || formData?.messageContent || formData?.messageText || '',
          messageText: formData?.message || formData?.messageContent || formData?.messageText || '',
        }
      };

      const webhookUrl = 'https://hook.us2.make.com/o3s38nxwkn27iyiq8tp9sz2vr2x56u29';
      
      console.log('Sending webhook data:', webhookData);
      
      const response = await fetch(webhookUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(webhookData)
      });

      if (response.ok) {
        console.log('Telegram webhook sent successfully');
        return true;
      } else {
        console.error('Failed to send webhook:', response.statusText);
        return false;
      }
    } catch (error) {
      console.error('Error sending Telegram webhook:', error);
      return false;
    } finally {
      setIsLoading(false);
    }
  };

  return {
    triggerWebhook,
    isLoading
  };
};
